function loadKewir(view) {
    return () => import( /* webpackChunkName: "kewir-[request]" */ `../../views/KampusMerdeka/Kewir/${view}.vue`)
}
function loadBimbinganKewir(view) {
    return () => import( /* webpackChunkName: "bimbinganKewir-[request]" */ `../../views/KampusMerdeka/BimbinganKewir/${view}.vue`)
}

const kewirRoute = [
    {
        path: '/kampus-merdeka/kewir',
        name: 'KewirMahasiswaView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKewir('MahasiswaView')
    },
    {
        path: '/kampus-merdeka/kewir-verify',
        name: 'EntrepreneurshipVerifyView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKewir('EntrepreneurshipVerifyView')
    },
    {
        path: '/kampus-merdeka/external-user',
        name: 'ExternalUserView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKewir('ExternalUserView')
    },
    {
        path: '/kewirausahaan-logbook/:id',
        name: 'LogbookKewir',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKewir('LogbookKewir')
    },
    {
        path: '/kewirausahaan-dosbim/:kewir_id',
        name: 'DosbimKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKewir('EntrepreneurshipAdvisor')
    },
    {
        path: '/kewirausahaan-rubric',
        name: 'RubricKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKewir('RubricCategory')
    },
    {
        path: '/kewirausahaan-rubric/:category_id',
        name: 'RubricFieldKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKewir('RubricField')
    },
    {
        path: '/kewirausahaan-exam/:detail_id',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKewir('MainViewExam'),
        children: [
            {
                path: '',
                name: 'Ujian Kewirausahaan',
                component: loadKewir('ExamDetail')
            },
            {
                path: 'pembimbing-profesional',
                name: 'Penilaian Pembimbing Profesional',
                component: loadKewir('MentorRubric')
            },
            {
                path: 'lecture',
                name: 'Penilaian Dosen Pembimbing Kewirausahaan',
                component: loadKewir('LectureRubric')
            },
            {
                path: 'result',
                name: 'Nilai Kewirausahaan',
                component: loadKewir('KewirResult')
            }
        ]
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kewir/:student_id',
        name: 'MyStudentGuidancesKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKewir('ListBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kewir',
        name: 'MyGuidanceStudentsKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKewir('ListMahasiswaBimbingan')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kewir/:student_id/:guidance_id',
        name: 'ResponseMyStudentGuidanceKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKewir('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/kewir/:guidance_id',
        name: 'ResponseGuidanceKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKewir('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/kewir',
        name: 'ListBimbinganKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKewir('ListBimbingan')
    },
    {
        path: '/kampus-merdeka/form/bimbingan/kewir',
        name: 'FormBimbinganKewirausahaan',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKewir('FormBimbingan')
    },
    {
        path: '/kewirausahaan-exam',
        name: 'KewirausahaanVerifyExam',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadKewir('VerifyExam')
    },
    {
        path: '/konversi-kewirausahaan',
        name: 'StudentConvertionViewKewir',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi']
        },
        component: loadKewir('StudentConvertionView')
    },
    {
        path: '/konversi-kewirausahaan/mata-kuliah/:id',
        name: 'ConvertionViewKewir',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi']
        },
        component: loadKewir('ConvertionView')
    },
    {
        path: '/konversi-kewirausahaan/mata-kuliah/:id/TU',
        name: 'ConvertionViewKewirAdmin',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator', 'mahasiswa']
        },
        component: loadKewir('ConvertionViewAdmin')
    },
]

export default kewirRoute